import { CopyButton } from "@/components/ui/CopyButton";
import { Breadcrumbs, Typography } from "@mui/material";

type Props = {
  id: string;
};

export function ImageBreadcrumbs({ id }: Props) {
  return (
    <Breadcrumbs separator="·">
      <CopyButton text={id}>
        <Typography>{`Image ID: ${id}`}</Typography>
      </CopyButton>
    </Breadcrumbs>
  );
}
